module.exports = __webpack_public_path__ + "img/healthcare_icon_2.42c432ce.png";